module.exports = __webpack_public_path__ + "img/16d001-08.3e807a88.png";